<ng-content select=".external-close-button"></ng-content>
<div class="sg-flex-column sg-full-height">
  <div style="min-height: 0" [sg-blockable]="(busy | async) ?? false" class="sg-flex-column sg-full-height sg-scrollable">
    @if (_showMiniHeader) {
    <div class="sg-flex-row detail-item-card-mini-title sg-justify-between sg-items-center">
      <div class="sg-flex-row sg-gap-15">
        @if (busy | async | sgNegate) {
        <mat-icon color="primary" class="mat-h2 sg-self-start sg-gap-8">{{ icon }}</mat-icon>
        } @else {
        <mat-spinner diameter="24"></mat-spinner>
        }
        <div class="sg-flex-column">
          <span class="mat-h2 detail-item-header" data-test="positionCategory">{{ category }}</span>
          <div class="sg-flex-row sg-gap-5">
            <div class="mat-h3 detail-item-subtitle">
              {{ subtitle }} @if (tag) {
              <span class="sg-tag {{tag.status}}">{{ tag.text }}</span>
              }
            </div>
          </div>
        </div>
      </div>
      <div><ng-content select=".sg-detail-item-card-top-action-row"></ng-content></div>
    </div>
    } @if (header) {
    <div style="margin-bottom: 16px" class="sg-flex-row sg-justify-start sg-items-center sg-full-width">
      <div class="sg-flex-auto">
        <h1 class="sg-no-margin">{{ header.title }}</h1>
        @if (header.subtitle) {
        <div style="font-size: 13px; margin-top: -2px" class="sg-color-disabled">{{ header.subtitle }}</div>
        }
      </div>
    </div>
    } @if (busy | async | sgNegate) {
    <div class="sg-flex-column-fill-no-overflow"><ng-content select=".sg-detail-item-card-content"></ng-content></div>
    @if (!_showActionOnBusy) {
    <div class="sg-flex-auto sg-self-end"><ng-container *ngTemplateOutlet="action"></ng-container></div>
    } }
  </div>
  @if (_showActionOnBusy) {
  <div class="sg-flex-auto sg-self-end"><ng-container *ngTemplateOutlet="action"></ng-container></div>
  }
</div>
<ng-template #action><ng-content select=".sg-detail-item-card-bottom-action-row"></ng-content></ng-template>
